/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterCSmall = createReactComponent("outline", "letter-c-small", "IconLetterCSmall", [["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }]]);

export { IconLetterCSmall as default };
//# sourceMappingURL=IconLetterCSmall.mjs.map
